import { useMutation, useQuery } from '@tanstack/react-query';
import { getWorkspaceIdFromCurrentUrl } from '@/context/current-workspace';
import { postUserFlags } from './api';
import { getAccount } from '../auth/api';

import type { UserFlags } from './api';

type setUserFlagsProps = {
  accountId: number | undefined;
  userId: number | undefined;
  flags: Partial<UserFlags>;
};

export const useGetUserFlags = () => {
  const workspaceId = getWorkspaceIdFromCurrentUrl();
  return useQuery({
    queryKey: ['userAccountForWorkspace', workspaceId],
    queryFn: async () => getAccount(workspaceId as number).then((data) => data.user.user_flags),
    enabled: workspaceId !== null, // Disable the query if workspaceId is null
  });
};

export const useSetUserFlags = () => {
  return useMutation({
    mutationFn: async (props: setUserFlagsProps) => postUserFlags(props.accountId, props.userId, props.flags),
  });
};
